import { Input, InputProps } from 'antd';
import styled from 'styled-components';
import { inputStyle } from 'consts/styles/inputStyle';

export type AppInputProps = InputProps & {
    accessibilityLabel?: string;
};

const StyledInput = styled(Input)<AppInputProps>`
    ${inputStyle}
`;

export const AppInput = ({ accessibilityLabel, ...props }: AppInputProps) => (
    <StyledInput aria-label={accessibilityLabel} {...props} />
);
